<template>
  <div class="page">
    <div class="breadcrumb">
      <router-link to="/home">上海盛目实业集团有限公司</router-link>
      <span>></span>
      <router-link to="/project">投资项目</router-link>
    </div>
    <div class="list">
      <div class="list-item" v-for="i in recruit" :key="i.id">
        <div class="left">
          <div class="title">
            <p>{{i.projectName}}</p>
          </div>
          <div class="txt">
            <p v-html="i.projectBriefIntroduction"></p>
          </div>
          <div class="btn">
            <router-link :to="`/project-info?id=${i.id}`">
              <span>查看详情>></span>
            </router-link>
          </div>
        </div>
        <div class="right">
          <img :src="i.projectUrl" alt="">
        </div>
      </div>
    </div>
    <div class="pagination">
      <el-pagination background prev-text="上一页" next-text="下一页" layout="prev, pager, next" :page-size="size" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { projectAllPage } from '@/api/api'
export default {
  data() {
    return {
      page: 1,
      size: 10,
      total: 100,
      recruit: []
    }
  },
  created() {
    this.getProjectAllPage()
  },
  computed: {},
  methods: {
    currentPage(e) {
      this.page = e
      this.getProjectAllPage()
    },
    getProjectAllPage() {
      projectAllPage({
        page: this.page,
        size: this.size
      }).then(res => {
        this.total = res.total
        this.recruit = res.records
      })
    },
    handleTime(time) {
      return this.$moment(time).format('YYYY-MM-DD')
    }
  }
}
</script>

<style lang="scss" scoped>
$page-center: 1200px;
.page {
  width: $page-center;
  margin: auto;
  .breadcrumb {
    margin: 50px auto 50px;
  }
  .list {
    width: 1100px;
    margin: auto;
    margin-bottom: 60px;
    &-item {
      display: flex;
      max-height: 310px;
      overflow: hidden;
      justify-content: space-between;
      padding: 25px 0;
      border-bottom: 1px solid #ccc;
      .left {
        width: 55%;
        .title {
          font-size: 20px;
          font-weight: 700;
          color: #1c3c8a;
          margin-bottom: 20px;
        }
        .txt {
          text-indent: 2em;
          font-size: 15px;
          color: #666;
          margin-bottom: 50px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 5;
          -webkit-box-orient: vertical;
        }
        .btn {
          padding: 5px 20px;
          background-color: #1c3c8a;
          color: #fff;
          display: inline-block;
          cursor: pointer;
          a {
            color: #fff;
            text-decoration: none;
          }
        }
      }
      .right {
        width: 42%;
      }
    }
  }
  ::v-deep .pagination {
    text-align: center;
    margin-bottom: 60px;
    .btn-prev,
    .btn-next {
      padding: 0 15px;
    }
  }
}
</style>
